var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('DaiCapaGeojson',{attrs:{"id":_vm.idCapa,"url":"data/capas/paises_con_actores.geojson","estilo-capa":{
      fill: { color: 'transparent' },
      stroke: { color: 'black' },
    },"z-index":3,"contenidoTooltip":(f) => `País: ${f.pais}<br />` + `Personas por ubicación | ${1}<br />`,"zoom-al-dar-click":false},on:{"click_feature":([f]) => _vm.cambiarCvesPais(f.get('codigo'))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }